module.exports = __webpack_public_path__ + "img/nav_icon_notification.7be07354.svg";